<div
  class="notifications-bar notifications-bar-collapsed"
  [ngClass]="{ 'notifications-bar-collapsed': isNotificationsbarCollapsed() }"
>
  <div class="notifications-bar-container">
    <p>Notifications are in development...</p>
  </div>
</div>
